'use client';

import { getEnv } from 'common-nextjs';

export default function fireTikTokEvent(...args: any[]) {
  if (getEnv() !== 'production') {
    console.groupCollapsed('TikTok Event');
    args.forEach(arg => console.log(arg));
    console.groupEnd();
  }

  if (window.ttq) {
    window.ttq.track(...args);
  }
}
